import { imageUrl } from 'app/frontend/base/helpers'

type Props = {
  spellId: number
  className?: string
}

const SpellIcon = ({ spellId, className }: Props) => {
  return <img className={className} src={imageUrl(`icons/${spellId}.jpg`)} />
}

export default SpellIcon
